import React from 'react'
import TopNav from '../components/TopNav'
import { LMS_ENTRY_FEE } from '../lmsConfig'

const RULES = [
  {
    n: '01',
    t: 'Pick one team, every gameweek',
    b: "Each gameweek, pick one team from that week's actual fixtures. That's your survival pick."
  },
  {
    n: '02',
    t: 'Win to survive',
    b: "Your team wins, you're through to the next gameweek. Draw or lose, and you're out."
  },
  {
    n: '03',
    t: 'No repeats',
    b: "Once you've picked a team in a round, you can't pick it again in that same round. Choose carefully."
  },
  {
    n: '04',
    t: 'Miss the deadline, get auto-picked',
    b: "Picks lock at kickoff of the gameweek's first fixture. Forget to pick, and the system auto-picks the lowest-placed team in the table that's still eligible for you. Auto-picks are flagged so everyone can see."
  },
  {
    n: '05',
    t: 'Last one standing wins',
    b: "Survive longer than everyone else in your round and you take the entire pot."
  },
  {
    n: '06',
    t: 'Everyone out together? Rollover.',
    b: "If every remaining player is eliminated in the same gameweek, nobody wins. The pot rolls into the next round instead."
  },
  {
    n: '07',
    t: `R${LMS_ENTRY_FEE} in, all of it in the pot`,
    b: `Every round is R${LMS_ENTRY_FEE} to enter, rollover or not, and every rand goes into the prize pool. Predicta takes no cut. If a round rolls over, the pot carries forward and every new entry adds R${LMS_ENTRY_FEE} to it.`
  }
]

export default function HowToPlay() {
  return (
    <div>
      <TopNav active="how-to-play" />

      <div className="container-narrow">
        <div style={{ textAlign: 'center', paddingTop: '32px', marginBottom: '28px' }}>
          <h1 style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '32px', marginBottom: '8px' }}>How to play</h1>
          <p style={{ color: 'var(--text-2)' }}>Last Man Stands, in plain language</p>
        </div>

        {RULES.map(r => (
          <div key={r.n} className="card">
            <div className="gold-text" style={{ fontFamily: 'var(--ff-d)', fontWeight: '800', fontSize: '32px', marginBottom: '10px', opacity: 0.85 }}>
              {r.n}
            </div>
            <div style={{ fontWeight: '700', fontSize: '16px', marginBottom: '6px' }}>{r.t}</div>
            <div style={{ color: 'var(--text-2)', fontSize: '13px', lineHeight: '1.65' }}>{r.b}</div>
          </div>
        ))}

        <div className="card-gold card" style={{ textAlign: 'center', marginTop: '8px', marginBottom: '32px' }}>
          <p style={{ fontSize: '13px', color: 'var(--text-2)', marginBottom: '14px' }}>Ready to get in?</p>
          <a href="/" className="btn btn-primary">Back to the game</a>
        </div>
      </div>
    </div>
  )
}
